const html = document.querySelector('html');
export default html;
